import { ReactElement } from "react";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import clsx from "clsx";
import { IButton } from "../Button/Button.types";

interface IModalFooter {
  actions?: Array<IButton>;
  leftContent?: ReactElement | null;
}

const ModalFooter: React.FC<IModalFooter> = ({ actions = [], leftContent }) => {
  if (!actions?.length && !leftContent) return null;

  return (
    <div
      className={clsx([
        "flex",
        "w-full",
        "gap-3",
        {
          "justify-end": !leftContent,
          "justify-between": leftContent,
        },
        "p-4 pt-2",
        "md:p-4",
        "items-center",
        "relative",
        "after:content-['']",
        "after:h-[20px]",
        "after:-top-[20px]",
        "after:absolute",
        "after:left-0",
        "after:right-0",
        "after:bg-gradient-to-t",
        "after:dark:from-gray-800",
        "after:dark:via-gray-800",
        "after:dark:to-gray-800/20",
        "after:from-white",
        "after:via-white",
        "after:to-white/10",
        "after:z-1",
      ])}
    >
      {leftContent && leftContent}
      {actions?.length > 0 && (
        <div className="flex w-full justify-end">
          <ButtonGroup buttons={actions} gap={1} layout="horizontal" />
        </div>
      )}
    </div>
  );
};

export default ModalFooter;
